import React from 'react'
import { l, StateScreen } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { AiAutomationBehaviorActions } from 'apps/aiAutomation/store/behavior'

const COPIES = {
  sidebar: {
    header: l.makeTranslate('First, get AI to sound like you'),
    text: l.makeTranslate(
      'AI Behavior captures your tone from your Instagram bio and comments. Tweak it until it feels right.',
    ),
  },
  page: {
    header: l.makeTranslate('Shape how AI should  behave to people'),
    text: l.makeTranslate(
      'AI captures your behavior from Instagram bio and comments to back it up, you can tweak it.',
    ),
  },
}

export const EmptyState = ({ source }: { source: 'sidebar' | 'page' }) => {
  const dispatch = useAppDispatch()

  return (
    <StateScreen
      className="m-x-auto"
      action={{
        label: l.translate('Set AI Behavior'),
        onClick: () => dispatch(AiAutomationBehaviorActions.initGenerationFx()),
      }}
      status="empty"
      header={l.getString(COPIES[source].header)}
      icon="AiKnowledge"
      text={l.getString(COPIES[source].text)}
      type="icon"
    />
  )
}
